import React, {useEffect} from 'react';
import {MainTop} from "../../../groups/group-container/main-top/Main-top";
import {ReactComponent as ArrayLeftIcon} from '../../../../../assets/main/groups/main-table/array-left.svg';
import {RootState} from "app/store";
import {
    TestTable
} from "components/pages/test/students-test/separate-test/separate-test-table/test-tabs/test-table/TestTable";
import {useAppDispatch, useAppSelector} from "common/hook";
import {StudentsTest} from "./students-test/StudentsTest";
import {useParams} from "react-router-dom";
import AuthWrapper from "../../../../auth-wrapper/AuthWrapper";
import {Skeleton} from 'antd';
import {fetchTest} from "features/model/service/test/get-test/fetchTest";


export const SeparateTest = () => {
    const activeTab = useAppSelector((state: RootState) => state.topTabs.activeTabs);
    const testData = useAppSelector(state => state.getTests.model)
    const dispatch = useAppDispatch();
    const {testId} = useParams();

    const activeTabs = useAppSelector((state) => state.topTabs.activeTabs);


    useEffect(() => {
        dispatch(fetchTest(testId));
    }, [dispatch]);

    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop
                    title={testData.title || <Skeleton.Input active={true}/>}
                    testStudent={true}
                    tabs={false}
                    setting={false}
                    edit={false}
                    editTest={true}
                    link={'/test'}
                    icons={<ArrayLeftIcon/>
                    }/>
                {activeTab.includes(0) && <TestTable/>}
                {activeTab.includes(1) && <StudentsTest/>}
            </div>
        </AuthWrapper>
    );
};



// useEffect(() => {
//     dispatch(fetchTestByTestId(testId));
// }, [dispatch, testId]);


// useEffect(() => {
//     dispatch(fetchTestStudentsById(testId));
// }, [dispatch, testId]);

